import { Component, OnInit, ViewChild } from "@angular/core";
import { TokenStorageService } from "../_services/token-storage.service";
import { AuthService } from "../_services/auth.service";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
  ValidatorFn,
  AbstractControl,
  ValidationErrors,
} from "@angular/forms";
import { Router } from "@angular/router";
import { ServicioGeneral } from "../_services/servicio-general.service";
import { NotificationService } from "../_services/notification.service";
import { UserService } from "../_services/user.service";
import { firstValueFrom } from "rxjs";
import { MatLegacyTableDataSource as MatTableDataSource } from "@angular/material/legacy-table";
import { MatLegacyPaginator as MatPaginator } from "@angular/material/legacy-paginator";
import { MatSort } from "@angular/material/sort";
import { Direccione } from "../model/third_model";
import { RaizComponent } from "../raiz/raiz.component";
import { ConfirmarCorreoService } from "../_services/confirmar-correo.service";
import { ConfirmDeleteDialogComponent } from "../gestion-usuarios/dialogs/confirm-delete-dialog.component";
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ConfirmOtpDialogComponent } from "../modal/confirm-otp/confirm-otp-dialog.component";
import { TranslateService } from "@ngx-translate/core";
import { ClientLoaderService } from "../core/util/client-loader.service";


@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.scss"],
})
export class ProfileComponent implements OnInit {

  constructor(
    private token: TokenStorageService,
    private _authService: AuthService,
    private _usuarioService: UserService,
    private _formBuilder: FormBuilder,
    private _router: Router,
    private _servicioGeneral: ServicioGeneral,
    private _notificationSvc: NotificationService,
    private userService: UserService,
    private raiz: RaizComponent,
    private _confirmacionCorreo: ConfirmarCorreoService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private clientLoader: ClientLoaderService,
  ) { }
  displayedColumns: string[] = ['id', 'nombre', 'Acciones'];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  //Variables
  isSuccessful = false;
  isSignUpFailed = false;
  errorMessage = "";
  currentUser = this.token.getUser();
  email : string = this.currentUser.email;
  editandoMail: boolean = false;
  errorQR: boolean = false;
  tfActivated: boolean = false;
  isShown: boolean = false;
  loading: boolean = false;
  vpnActivaMandatory = false;
  update: boolean = false;
  submitted: boolean = false;
  newdirection: boolean = false;
  qr: any;
  TPersonas: any = [];
  TDocumentos: any = [];
  userFormDirecciones: Array<any> = [];
  numeroDirecciones: number = 0;
  TComunidades: any = [];
  TProvincias: any = [];
  provincias = this._servicioGeneral.getProvincias();
  TMunicipios: any = [];
  municipios = this._servicioGeneral.getMunicipios();
  TVias: any = [];
  TPais: any = [];
  direccion: Direccione | undefined ;
  dataSourceRepresento = new MatTableDataSource<any>();
  dataSourceMeRepresenta = new MatTableDataSource<any>();
  dataSourcePendienteMeRepresenta = new MatTableDataSource<any>();
  dataSourceSearchUser = new MatTableDataSource<any>();
  documentSearch;
  blockEnvioCorreo: boolean = false;

  checkPasswords: ValidatorFn = (group: AbstractControl):  ValidationErrors | null => { 
    let password = group.get('password').value;
    let confirmPassword = group.get('password_confirmacion').value
    return password === confirmPassword ? null : { notSame: true }
  }

  form: FormGroup = new FormGroup( {
    nombre_responsable: new FormControl({value:"", disabled: true}), 
    numero_documento_responsable: new FormControl({value:"", disabled:true}),
    apellido1_responsable: new FormControl({value:"", disabled:true}),
    apellido2_responsable: new FormControl({value:"", disabled: true}),
    tipo_persona_responsable: new FormControl({value:"", disabled: true}),
    tipo_documento_responsable : new FormControl({value:"", disabled: true}),
    nombre: new FormControl({value:"", disabled: true}, Validators.required), 
    apellido1: new FormControl({value:"", disabled: true}, Validators.required),
    apellido2: new FormControl({value:"", disabled: true}),
    tipo_persona: new FormControl({value:"", disabled: true}, Validators.required),
    tipo_documento : new FormControl({value:"", disabled: true}, Validators.required),
    telefono : new FormControl("", [Validators.required, Validators.pattern("^[6,7]{1}[0-9]{8}")]),
    numero_documento : new FormControl({value:"", disabled: true}, Validators.required),
    tipo_via: new FormControl("", Validators.required),
    nombre_via: new FormControl("", Validators.required),
    numero_via: new FormControl("", Validators.required),
    bloque: new FormControl(""),
    escalera: new FormControl(""),
    piso: new FormControl(""),
    puerta: new FormControl(""),
    codigo_postal: new FormControl("", [Validators.required, Validators.pattern("^(?:0[1-9]\\d{3}|[1-4]\\d{4}|5[0-2]\\d{3})$")]),
    pais: new FormControl("", Validators.required),
    ccaa: new FormControl("", Validators.required),
    provincia: new FormControl("", Validators.required),
    municipio: new FormControl("", Validators.required),
  }, {});

  form2: FormGroup = new FormGroup({});

  form3: FormGroup = new FormGroup({
    totpkey: new FormControl("", [Validators.required, Validators.minLength(6), Validators.maxLength(6)])
  });

  //Init
  ngOnInit(): void {
    this.vpnActivaMandatory = this.clientLoader.isVpnActiva();
    //this.token.saveUser();
    this.getDocumentos();
    this.getTipoPersona();
    this.getVias();
    this.getPais();
    this.getComunidades();
    this.getProvincias();
    this.userData();
    this.update = false;

    if(this.currentUser.tfa && this.currentUser.tfa != "disabled"){
      this.tfActivated = true;
    } 

    
  }

  //Funciones
  nuevaDireccion() {
    let auxDirection: Direccione = undefined;
    this.userFormDirecciones.push(auxDirection);
  }


  getFirstLetter(nombre: string) {
    return nombre.charAt(0).toUpperCase();
  }

  userData():void {
    if(this.currentUser.email==null){
      this.form.addControl("email", new FormControl("",[ Validators.required,Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$') ]));
      this.form.addControl("password", new FormControl("", [Validators.required, Validators.minLength(6)]));
      this.form.addControl("password_confirmacion", new FormControl("", [Validators.required,]));
      this.form.addValidators(this.checkPasswords);
    }
    else{
      this.form.addControl("email", new FormControl("", Validators.required));

      this.form.patchValue({
        email: (this.currentUser.email) ? this.currentUser.email : ''
      });
    }

    this.form.patchValue({
      tipo_persona: (this.currentUser.tipopersona) ? this.currentUser.tipopersona["id"] : '',
      nombre: this.currentUser.nombre,
      apellido1: this.currentUser.apellido1,
      apellido2: this.currentUser.apellido2,
      telefono: (this.currentUser.telefono) ? this.currentUser.telefono : '',
      tipo_documento: (this.currentUser.tipo_documento) ? this.currentUser.tipo_documento["id"] : '',
      numero_documento: (this.currentUser.numero_documento) ? this.currentUser.numero_documento : '',
    });
    if(this.currentUser.usuarioRepresenta && this.currentUser.tipopersona.id == 2){  
      this.form.patchValue({
        tipo_persona_responsable: (this.currentUser.usuarioRepresenta.tipopersona) ? this.currentUser.usuarioRepresenta.tipopersona["id"] : '1',
        nombre_responsable: this.currentUser.usuarioRepresenta.nombre ?? '',
        apellido1_responsable: this.currentUser.usuarioRepresenta.apellido1,
        apellido2_responsable: this.currentUser.usuarioRepresenta.apellido2,
        tipo_documento_responsable: (this.currentUser.usuarioRepresenta.tipo_documento) ? this.currentUser.usuarioRepresenta.tipo_documento.id : '1',
        numero_documento_responsable: (this.currentUser.usuarioRepresenta.numeroDocumento) ? this.currentUser.usuarioRepresenta.numeroDocumento : '',
      })
    }
    
    if (this.currentUser.direcciones.length != 0) {
      this.direccion=this.currentUser.direcciones[0];
      this.getMunicipios();
      this.form.patchValue({
        tipo_via: this.direccion?.type_of_road.id??'',
        nombre_via: this.direccion?.name_road??'',
        numero_via: this.direccion?.number_road??'',
        bloque: this.direccion?.block??'',
        escalera: this.direccion?.stairs??'',
        piso: this.direccion?.floor??'',
        puerta: this.direccion?.door??'',
        codigo_postal: this.direccion?.postal_code??'',
        pais: this.direccion?.country.id??'',
        ccaa: this.direccion?.ccaa.id??'',
        provincia: this.direccion?.province.id??'',
        municipio: this.direccion?.municipality??'',
        isactive: this.direccion?.isActive
      });
    } 
    
    /*else {
      this.nuevaDireccion();
      this.newdirection = !this.newdirection;
    }*/
    if(this.currentUser.email==null){
      this._notificationSvc.info('Atención.','Debe completar sus datos de perfil para acceder a trámites');
    }
  // this.consultarStatus();
  //this.getRepresentedUsers();

  }

  async onSubmit(): Promise<any> {
    this.submitted = true;
    this.update = false;


    if(this.form.get('codigo_postal').hasError('pattern')){
      this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), this.translate.instant('PROFILE.MSG.INVALID_CP'), 5000);
      return false;
    }
    if(this.currentUser.email==null){
      if(this.form.get('password').hasError('minLength')){
        this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), this.translate.instant('PROFILE.MSG.PASSWORD_MIN'), 5000);
        return false;
      }
  
      if(this.form.hasError('notSame')){
        this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), this.translate.instant('PROFILE.MSG.PASSWORD_MISMATCH'), 5000);
        this.form.controls['password_confirmacion'].setErrors({'incorrect': true});
        return false;
      }
    }

    if(!this.form.valid) {
      this._notificationSvc.warning(this.translate.instant('COMMON.INFO'), this.translate.instant('PROFILE.MSG.FILL_FIELDS'), 5000);
      return false;
    } else {
      if((this.currentUser.email != null 
        && this.currentUser.email !== this.form.value.email) 
        &&(this.currentUser.telefono != null && this.currentUser.telefono !== this.form.value.telefono )){
          this._notificationSvc.warning(this.translate.instant('COMMON.INFO'), this.translate.instant('PROFILE.MSG.PHONE_EMAIL_BOTH'), 5000);
          return false;
      }
      else if(this.currentUser.email != null    && this.currentUser.email !== this.form.value.email){
        this.openValidateOtpMailDialog('MOVIL');
      }
      else if(this.currentUser.telefono != null && this.currentUser.telefono !== this.form.value.telefono ){
        this.openValidateOtpMailDialog('MAIL');
      }
      else{
        this._authService.updateUser(this.form.value).subscribe({  
          next: async data => {
            if(this.currentUser.email == null){
              this._notificationSvc.info('Hecho', "Se ha enviado un mensaje de confirmación a su correo electrónico", 50000);          
            } else {
              this._notificationSvc.success(this.translate.instant('COMMON.DONE'), this.translate.instant('PROFILE.MSG.UPDATED'), 50000);          
            }
            
            this.token.saveToken(data.accessToken);
            this._usuarioService.getCurrentUserFromServer().subscribe({
              next: async data => { 
                this.token.setUser(data.Usuario,data.usuarioRepresenta);
                
                this.isSignUpFailed = false;
                this.update = true;
                this.raiz.reloadHeader=!this.raiz.reloadHeader; 

                let reload = this._router.url.includes('action')?this._router.url.slice(1):this._router.url.slice(1).concat('?action=20')
                this._router.navigate(['inicio'], { skipLocationChange: true }).then(() => {
                  this._router.navigateByUrl(reload);
                });
                
              },
              error: err => {
                this.update = false;
                
                if(err.status == 226){
                  this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), err.error.text, 50000);
                  this.form.controls['numero_documento'].setErrors({'incorrect': true});
                } 
      
                if(err.status == 406){
                  this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), err.error , 50000);
                  this.form.controls['numero_documento'].setErrors({'incorrect': true});
                }
      
                if(err.error.status == 628){
                  this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), err.error.message , 50000);
                  this.form.controls['email'].setErrors({'incorrect': true});
                }
      
                if(err.error.status == 627){
                  this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), err.error.message , 50000);
                  this.form.controls['email'].setErrors({'incorrect': true});
                }
                this.isSignUpFailed = true;
              }
            });
          
          },
          error: err => {
            //console.log(err);
            this.update = false;
            
            if(err.status == 226){
              this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), err.error.text, 50000);
              this.form.controls['numero_documento'].setErrors({'incorrect': true});
            } 

            if(err.status == 406){
              this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), err.error , 50000);
              this.form.controls['numero_documento'].setErrors({'incorrect': true});
            }

            if(err.error.status == 628){
              this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), err.error.message , 50000);
              this.form.controls['email'].setErrors({'incorrect': true});
            }

            if(err.error.status == 627){
              this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), err.error.message , 50000);
              this.form.controls['email'].setErrors({'incorrect': true});
            }
            this.isSignUpFailed = true;
          }
        });
      }
    }
  }

  searchUser(): any {
    /*this._authService.getUserData().subscribe({
      next: (data) => {
         data;
        firstValueFrom(this.userService.getCurrentUserRepresented()).then((dataRepresented) => {
          this.currentUser.representados = dataRepresented.representa
          this.currentUser.esRepresentado = dataRepresented.representado_por
        })
      },
      error: (error) => {
        //console.log(error);

      }
    })*/
  }


  cerrarActivacion2FA(): void {
    this.isShown = false;
    this.loading = false;
    this.errorQR = false;
    this.qr = null;
    this.form3.reset();
  }

  pedirQR(): void {
    this.loading = true;
    this.errorQR = false;
    this._authService.pedirQr().subscribe({
      next: (data) => {
        this.qr = data;
        this.isShown = true;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.errorQR = true;
      }
    });
  }

  guardarQR(): void {
    const code = (this.form3.get('totpkey')?.value ?? '').toString().trim();
    if (code.length < 6) {
      this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), this.translate.instant('PROFILE.MSG.CODE_INVALID'), 5000);
      return;
    }

    this._authService.guardarQR(this.qr.secret, code).subscribe({
      next: (data) => {
        if (data?.result === 'success') {
          this.tfActivated = true;
          this.errorQR = false;
          this.isShown = false;
          this.currentUser = { ...this.currentUser, tfa: data.secret };
          this._usuarioService.getCurrentUserFromServer().subscribe({
            next: (userData) => {
              this.token.setUser(userData.Usuario, userData.usuarioRepresenta);
              this.currentUser = userData.Usuario;
            }
          });
        } else {
          this.qr = data;
          this.errorQR = true;
          this.form3.reset();
        }
      },
      error: (err) => {
        if (err.error?.secret) {
          this.qr = err.error;
        }
        this.errorQR = true;
        this.form3.reset();
        if (err.error?.codigo == 637) {
          this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), this.translate.instant('PROFILE.MSG.CODE_INVALID'), 5000);
        } else {
          this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), this.translate.instant('PROFILE.MSG.TFA_FAIL'), 5000);
        }
      }
    });
  }

  quitarQR(): any {
    this._authService.quitarQR(false).subscribe({
      next: (data) => {
        this.qr = data;
        if (this.isShown) {
          !this.isShown;
        }
        this.tfActivated = false;
        this.form3 = this._formBuilder.group({
          totpkey: [""],
        });
      },
      error: (err) => {
        //console.log(err);
      }
    })
  }

  reenviarCorreo(): any {
    this.blockEnvioCorreo = true;
    this._confirmacionCorreo.getEmailConfirmacion(this.currentUser.email).subscribe({
      next: (data) => {
        this._confirmacionCorreo.reenviarCorreo(data.token).subscribe({
          next: (data) => {
            this._notificationSvc.info('Atención', 'El correo de confirmación se ha reenviado con éxito');
            this.blockEnvioCorreo = false;
          },
          error: (error) => {

          }
        })
      },
      error: (error) => {

      }
    })
    
  }

  consultarStatus(): any {
      if (!this.currentUser.twoFactorEnabled) {
         this.tfActivated = false;
       } else {
         this.tfActivated = true;
       }
  }

  scrollTop() {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }

  reloadToMenuOption(isAllPage: Boolean) {
    if (isAllPage) {
      var url = new URL(window.location.href);
      url.searchParams.set('action', '20');
      window.location.href = url.href;
    } else {
      this._router.routeReuseStrategy.shouldReuseRoute = function () {
        return false;
      }
      this._router.onSameUrlNavigation = 'reload';
      this.scrollTop()
      this._router.navigate(['/admin'], { queryParams: { action: 20 } });
    }
  }

  getTipoPersona() {
    return this._servicioGeneral.getTipoPersona().subscribe((data) => {
      this.TPersonas = data['TipoPersona'];
    });
  }

  getDocumentos() {
    return this._servicioGeneral.getTipoDocumento().subscribe((data) => {
      this.TDocumentos = data['TipoDocumento'];
    });
  }
  
  get documento() {
    return this.form.get("numero_documento");
  }

  getComunidades() {
    return this._servicioGeneral.getComunidades().subscribe((data) => {
      this.TComunidades = data['ComunidadAutonoma'];
    });
  }

  getProvincias() {
    return this._servicioGeneral.getProvincias().subscribe((data) => {
      this.TProvincias = data['Provincia'];
    });
  }

  onChangeProvincia(event: Event) {
    this.TProvincias = [];
    const id = (event.target as HTMLInputElement).value;
    this.getProvinciasByID(id);
  }

  getProvinciasByID(id: string) {
    this.provincias.subscribe(
      (data) => {
        data['Provincia'].forEach((provincia) => {
          if (provincia.ccaa["id"] == id) {
              this.TProvincias.push(provincia);
              return this.TProvincias;
            }
        });
      });
  }

  getMunicipios() {
    if(!this.direccion?.province["id"]){
      return this._servicioGeneral.getMunicipios().subscribe((data) => {
        this.TMunicipios = data;
      });
    }else{
      return this.getMunicipiosByID(this.direccion?.province["id"])
    }
  }

  onChangeMunicipio(event: Event) {
    this.TMunicipios = [];
    const id = (event.target as HTMLInputElement).value;
    this.getMunicipiosByID(id);
  }

  getMunicipiosByID(id: string) {
    this.municipios.subscribe( (data) =>{
      data['Municipio'].forEach((municipio) => {
        if(municipio.municipioPK["provincia"] == id){
          this.TMunicipios.push(municipio);
          return this.TMunicipios
        }
      });
    });
  }

  getVias() {
    return this._servicioGeneral.getTipoVias().subscribe((data) => {
      this.TVias = data['TipoVia'];
    });
  }

  getPais() {
    return this._servicioGeneral.getPais().subscribe((data) => {
      this.TPais = data['Pais'];
    });
  }

  unsubscribeUser(){
    this.userService.unsubscribeCurrentUser(this.token).subscribe({
      next: data => {
        if (data.status === "602") {
          this._notificationSvc.success(this.translate.instant('COMMON.DONE'), this.translate.instant('PROFILE.MSG.DEACTIVATED'), 50000);
          setTimeout(() => {
            this.logout();
          }, 5000);
        }
      },
      error: (err) => {
         if (err.error.status === "613") {
          this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), this.translate.instant('PROFILE.MSG.ALREADY_DEACTIVATED'), 50000);
        }
        else{
          this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), this.translate.instant('PROFILE.MSG.DEACTIVATE_FAIL'), 50000);
        }
      }
    });
  }

  logout(): void {
    this.token.signOut();
    window.location.reload();
  } 

  
  openDeleteDialog() {
    const nombre = [this.currentUser?.nombre, this.currentUser?.apellido1].filter(Boolean).join(' ');
    const ref = this.dialog.open(ConfirmDeleteDialogComponent, {
      data: {
        title: 'Dar de baja',
        message: `¿Seguro que quieres dar de baja a «${nombre}»? La cuenta quedará desactivada.`,
        confirmLabel: 'Dar de baja'
      },
      panelClass: 'gu-dialog-panel'
    });
    return ref.afterClosed().subscribe((ok) => {
      if (!ok) return;
      this.unsubscribeUser();
    });
  }
  openValidateOtpMailDialog(tipoOtp: string) {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.autoFocus = true;
    dialogConfig.width = '25vw';
    dialogConfig.minWidth = '500px';
    dialogConfig.data = { titulo:  (tipoOtp == 'MOVIL'?"cambio de email":"cambio de teléfono movil") , tipo: tipoOtp}
    
    const dialogRef = this.dialog.open(ConfirmOtpDialogComponent, dialogConfig);
    
    return dialogRef.afterClosed().subscribe(result => {
      if (result.result == 'Confirmar') {
        this.updateMail(tipoOtp);
      }
    })
  }
  updateMail(tipoOtp: string){
    this._authService.updateUser(this.form.value).subscribe({  
      next: async data => {
        if(tipoOtp == 'MOVIL'){
          this._notificationSvc.info('Hecho', "Se han realizado correctamente los cambios. Se ha enviado un mensaje de confirmación a su correo electrónico", 50000);          
          this.token.saveToken(data.accessToken);
        }
        else{
          this._notificationSvc.info('Hecho', "Se ha han realizado correctamente los cambios.", 50000);         
        }
        this._usuarioService.getCurrentUserFromServer().subscribe({
          next: async data => { 
            this.token.setUser(data.Usuario,data.usuarioRepresenta);
            
            this.isSignUpFailed = false;
            this.update = true;
            this.raiz.reloadHeader=!this.raiz.reloadHeader; 

            let reload = this._router.url.includes('action')?this._router.url.slice(1):this._router.url.slice(1).concat('?action=20')
            this._router.navigate(['admin'], { skipLocationChange: true }).then(() => {
              this._router.navigateByUrl(reload);
            });
            
          },
          error: err => {
            //console.log(err);
            this.update = false;
            
            if(err.status == 226){
              this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), err.error.text, 50000);
              this.form.controls['numero_documento'].setErrors({'incorrect': true});
            } 
  
            if(err.status == 406){
              this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), err.error , 50000);
              this.form.controls['numero_documento'].setErrors({'incorrect': true});
            }
  
            if(err.error.status == 628){
              this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), err.error.message , 50000);
              this.form.controls['email'].setErrors({'incorrect': true});
            }
  
            if(err.error.status == 627){
              this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), err.error.message , 50000);
              this.form.controls['email'].setErrors({'incorrect': true});
            }
            this.isSignUpFailed = true;
          }
        });
      
      },
      error: err => {
        //console.log(err);
        this.update = false;
        
        if(err.status == 226){
          this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), err.error.text, 50000);
          this.form.controls['numero_documento'].setErrors({'incorrect': true});
        } 

        if(err.status == 406){
          this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), err.error , 50000);
          this.form.controls['numero_documento'].setErrors({'incorrect': true});
        }

        if(err.error.status == 628){
          this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), err.error.message , 50000);
          this.form.controls['email'].setErrors({'incorrect': true});
        }

        if(err.error.status == 627){
          this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), err.error.message , 50000);
          this.form.controls['email'].setErrors({'incorrect': true});
        }
        this.isSignUpFailed = true;
      }
    });    
  }
}